module.exports = __webpack_public_path__ + "fonts/83c70adeda163147a31a5b1f5e35c925.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Quote/img/sign-in.svg
// module id = 2010
// module chunks = 0